export class CancelEvent {
    event: string = 'cancel';
}